import * as React from 'react';
import {
  Dialog,
  DialogContent,

} from '@material-ui/core';
import type { AxiosError } from 'axios';
import axios from 'axios';
import { useSnackbar } from 'notistack';

import type { IRefineResultsProps, IRepairResult } from '../../repairLookup/RepairLookupInterfaces';
import RepairResults from '../../repairLookup/RepairResults';

interface UserRepairsProps {
  onClose: () => void;
  open: boolean;
  userId: string;
}

const CourierOverrideModal: React.FC<UserRepairsProps> = ({
  onClose, open, userId,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [resultSet, setResultSet] = React.useState <Array<IRepairResult>>([]);
  const [loading, setLoading] = React.useState<boolean>(true);

  const filterSet = {
    repairType: { repairTypeName: '', repairTypeValue: 0 },
    repairBarcode: '',
    storeRepairNumber: '',
    company: { companyId: '', companyName: '' },
    store: { storeId: '', storeName: '' },
    location: '',
    startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 5)),
    endDate: new Date(),
    userId,
  };

  const handleRefineResults = (filterSetParam: IRefineResultsProps) => {
    setLoading(true);
    axios.post<Array<IRepairResult>>('/repairlookup/repairlookup', filterSetParam)
      .then((response) => {
        setResultSet(response.data);
        setLoading(false);
      })
      .catch((error: AxiosError) => {
        enqueueSnackbar(error?.response?.data, { persist: false, variant: 'error' });
        setLoading(false);
      });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => handleRefineResults(filterSet), [userId]);

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth
      maxWidth="xl"
    >
      <DialogContent>
        <RepairResults
          gridTitle="Currently Assigned Repairs"
          loading={loading}
          resultSet={resultSet || []}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CourierOverrideModal;
